"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgNoSkiLuggage = function SvgNoSkiLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.191 1.496a1.375 1.375 0 1 0-1.945 1.945l18.782 18.781a1.375 1.375 0 0 0 2.152-1.679.876.876 0 0 0-.266-1.49.439.439 0 0 1-.289-.412V7.73a.436.436 0 0 1 .149-.333.874.874 0 0 0 .288-.647V2.812a1.313 1.313 0 0 0-2.625 0V6.75a.876.876 0 0 0 .29.647.437.437 0 0 1 .148.333v10.45l-1.795-1.794.045-12.275a2.625 2.625 0 1 0-5.25 0l-.025 7.044-1.706-1.705-.019-5.325a2.625 2.625 0 0 0-5.25 0v.056L4.562 2.868v-.055A1.313 1.313 0 0 0 3.196 1.5l-.005-.005Zm9.637 15.527 5.196 5.223a.429.429 0 0 1-.131.169.42.42 0 0 1-.376.079l-4.375-.008a.429.429 0 0 1-.332-.42l.018-5.043Zm-1.663-1.672-5.247-5.275.086 11.986a.429.429 0 0 0 .166.341.42.42 0 0 0 .376.08l4.311.005a.429.429 0 0 0 .333-.42l-.025-6.717Zm-7.04-7.077L1.937 6.075v.675a.875.875 0 0 0 .29.647.438.438 0 0 1 .148.333v10.911a.438.438 0 0 1-.289.412.875.875 0 0 0 0 1.645.438.438 0 0 1 .289.41v.517a.875.875 0 1 0 1.75 0v-.516a.438.438 0 0 1 .289-.412.875.875 0 0 0 0-1.645.438.438 0 0 1-.289-.41V8.273Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgNoSkiLuggage);
var _default = exports["default"] = Memo;